import { Comment, Fragment } from 'vue'

/* Vue 2.6'da `this.$slots.x` slot içeriği boşsa (hiç düğüm yok ya da tek yorum düğümü, ör. içindeki
   tek öğe v-if ile gizli) `undefined` dönüyordu; Vue 3'te verilen her slot bir fonksiyondur ve içerik
   boş olsa da doğrudur. `!!this.$slots.x` ile kabuk (kart başlığı, sekme başlığı) çizen bileşenler
   Vue 2 sonucunu bununla alır. Render sırasında (computed/şablon) çağrılmalıdır. */
export function hasSlotContent(slot, props) {
  if (!slot) return false;
  if (typeof slot !== 'function') return !isEmpty(slot);
  return !isEmpty(slot(props));
}

function isEmpty(vnodes) {
  const nodes = (Array.isArray(vnodes) ? vnodes : [vnodes]).flatMap(node =>
    node && node.type === Fragment && Array.isArray(node.children) ? node.children : [node]);
  return nodes.length === 0 || (nodes.length === 1 && (!nodes[0] || nodes[0].type === Comment));
}
